import { render, staticRenderFns } from "./RegionToolbar.vue?vue&type=template&id=74dc04ca&scoped=true&"
import script from "./RegionToolbar.vue?vue&type=script&lang=js&"
export * from "./RegionToolbar.vue?vue&type=script&lang=js&"
import style0 from "./RegionToolbar.vue?vue&type=style&index=0&id=74dc04ca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74dc04ca",
  null
  
)

export default component.exports